export const dayToDayString = (day: number): string => {
  const dayStr = day.toString();

  if (dayStr.length === 2) {
    return dayStr;
  }

  return `0${dayStr}`;
};
